import { ShoppingBag } from "lucide-react";

export const ProductCard = ({ product, onOpen, accent = false }) => {
    const minPrice = Math.min(...product.sizes.map((s) => s.price));
    return (
        <button
            type="button"
            onClick={() => onOpen(product)}
            className={`group text-left bg-white rounded-3xl overflow-hidden sss-shadow hover:sss-shadow-lg transition-all duration-300 hover:-translate-y-1 flex flex-col ${accent ? "ring-1 ring-[var(--sss-pink)]/20" : ""}`}
            data-testid={`product-card-${product.id}`}
        >
            <div className="aspect-square bg-[var(--sss-blush)] overflow-hidden relative">
                <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
            </div>
            <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-serif-display text-xl font-semibold leading-tight">
                    {product.name} <span className="text-base">{product.emoji}</span>
                </h3>
                <p className="text-xs text-[var(--sss-text-muted)] mt-1 line-clamp-2">{product.description}</p>
                <div className="mt-4 flex items-center justify-between">
                    <span className="text-sm text-[var(--sss-text-muted)]">
                        {product.sizes.length > 1 ? "From " : ""}
                        <span className="font-serif-display text-lg font-bold text-[var(--sss-text)]">${minPrice.toFixed(2)}</span>
                    </span>
                    <span className="btn-pink !py-2 !px-4 text-sm" data-testid={`product-card-cta-${product.id}`}>
                        <ShoppingBag size={14} /> Order
                    </span>
                </div>
            </div>
        </button>
    );
};
